import * as api from '@/api/book.js'
import * as user from '@/api/user.js'
import storage from '@/assets/js/storage.js'
let isDev = false
let Gprefix = ''
let Gtype = 'h5'
let GRoot = ''
let GV = 'v1' // 全局ajax接口的版本控制，值为'v1' or 'v2'
let GVer = 'read'
let initUrl = 'common/init'
let GRegTel = /^1[3-9]\d{9}$/
let GRegEmail = /^\w+@\w+[.]\w{2,3}$/
// 环境配置
let istest = getQuery('istest')
let currhost = window.location.host
let testHosts = ['h5.test.sheep.qingyin.net:9888', 'h5.test.better.qingyin.net']
if (istest || testHosts.indexOf(currhost) > -1) {
  isDev = true
}
if (isDev) {
  Gprefix = 'https://better.test.qingyin.net/server/better/api'
} else {
  Gprefix = 'https://better.qingyin.net/server/better/api'
}
GRoot = 'http://' + window.location.host + '/'
export default {
	BDClickTj,
	BDPvTj,
	phoneStar,
	initUrl,
	GRegTel,
	GRegEmail,
	apihost: Gprefix,
	Gtype,
	Root: GRoot,
	GV,
	GVer,
	getQuery,
	URLProxy,
	ckLogin,
	goRouter,
	goPay,
	listModel,
	examTime,
	initMinuter,
	dataFormat,
	getTimeText,
	getTimeS,
	blurIn,
	ckMobile,
	getUserInfo,
	getPackageInfo,
	goTop,
	setTitle,
	isIOS,
	isMobile,
	header: ajaxHeader,
	ColorReverse,
	getColorRGB,
	checkColorPick,
	resourceUrl,
	resourceTypeText
}
// 资源类型
function resourceTypeText (v) {
	var typeArr = {
		1: '查看专栏',
		2: '查看图书',
		3: '观看直播',
		4: '查看课程',
		5: '收听夜谈',
		6: '查看会员',
		7: '开始学习'
	}
	return typeArr[v]
}
function resourceUrl (_this, info) {
	if (info.resource_type == 1 || info.resource_type == 2) {
		_this.$router.replace({name: 'bookIndex'})
	} else if (info.resource_type == 4 || info.resource_type == 7) {
		if (info.resource_type == 4 && info.type == 2) {
			_this.$router.replace({name: 'myCourse'})
		} else {
			_this.$router.replace({name: 'chapterList', params: {rtype: info.resource_type, rpid: info.resource_id, rid: info.resource_id}})
		}
	} else if (info.resource_type == 5) {
		_this.$router.replace({name: 'radioIndex', params: {resource_type: info.resource_type, resource_id: info.resource_id}})
	} else {
		_this.$router.replace({name: 'mine'})
	}
}
// 判断颜色是否接近于白色
function getColorRGB (sColor, opacity) {
	if (sColor) {
		sColor = sColor.toLowerCase()
	}
	// 十六进制颜色值的正则表达式
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
	// 如果是16进制颜色
	if (sColor && reg.test(sColor)) {
		if (sColor.length === 4) {
			var sColorNew = '#'
			for (var j = 1; j < 4; j++) {
				sColorNew += sColor.slice(j, j + 1).concat(sColor.slice(j, j + 1))
			}
			sColor = sColorNew
		}
		// 处理六位的颜色值
		var sColorChange = []
		for (var i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
		}
		if (opacity) {
			sColorChange.push(opacity)
			return 'rgba(' + sColorChange.join(',') + ')'
		} else {
			return 'rgb(' + sColorChange.join(',') + ')'
		}
	}
	return sColor
}
function checkColorPick (val) {
	var checkarr = val
	if (checkarr[0] >= 200 && checkarr[1] >= 200 && checkarr[2] >= 200) {
		return false
	} else {
		return val
	}
}
// 去颜色的反色
function ColorReverse (v) {
	var OldColorValue = '0x' + v.replace(/#/g, '')
	var str = '000000' + (0xFFFFFF - OldColorValue).toString(16)
	return '#' + str.substring(str.length - 6, str.length)
}
function ajaxHeader () {
	let v = {'Content-Type': 'application/x-www-form-urlencoded'}
	return v
}
function BDClickTj (v) {
	console.log('##### BDClickTj v = ' + JSON.stringify(v))
	window._hmt.push(['_trackEvent', v.type, v.action, v.tag])
}
function BDPvTj (v) {
	console.log('##### BDPvTj v = ' + GRoot + v)
	window._hmt.push(['_trackPageview', GRoot + v])
}
// *手机号
function phoneStar (p) {
	let reg = /^(.{3}).*(.{4})$/
	let val = p.replace(reg, '$1****$2')
	return val
}
// 获取地址栏参数
function getQuery (name) {
  var reg = new RegExp('(^|&|[?])' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  return (r != null ? r[2] : '')
}
// 接口路径
function URLProxy (uri, vFlag) {
  // 有版本号
  if (vFlag) {
	uri = GV + '/' + uri
  }
  let vnum = GV
  if (vnum !== 'v1') {
    uri = uri.replace('v1.', vnum + '.')
  }
  var url = Gprefix + '/' + Gtype + '/' + uri
  return url
}
// 微信授权
function getWxAuth (link, params) {
	var url = ''
	var opt = params || {}
	var scopes = opt.scopes || 0
	var href = link || window.location.href
	var backUrl = encodeURIComponent(href)
	var wx = opt.wx || 0
	var cur1 = encodeURIComponent(Gprefix + '/login?back=' + backUrl)
	url = 'https://oauth.qingyin.net/api/wx/oauth/a?scopes=' + scopes + '&curl=' + cur1 + '&wx=' + wx
	window.location.replace(url)
}
// 去授权
function goAuth (scopes) {
	getWxAuth(window.location.href, {scopes: scopes, wx: 2})
}
// 检查是否登录
function ckLogin (v) {
	if (!v) {
		goAuth(1)
	}
}
// 路由跳转
function goRouter (_this, name, v, flag) {
  if (flag) {
    _this.$router.replace({name: 'index'})
  } else {
    _this.$router.push({name: name, query: v})
  }
}
// 去购买
function goPay (notifyUrl, rtype, rid, cdc) {
	var url
	if (cdc) {
		url = Gprefix + '/' + Gtype + '/' + GV + '/pay/weixin?notify_url=' + encodeURIComponent(notifyUrl) + '&resource_type=' + rtype + '&resource_id=' + rid + '&cdc=' + cdc
	} else {
		url = Gprefix + '/' + Gtype + '/' + GV + '/pay/weixin?notify_url=' + encodeURIComponent(notifyUrl) + '&resource_type=' + rtype + '&resource_id=' + rid
	}
	window.location.replace(url)
}
// 一行n个数据
function listModel (list, n) {
	let index = 0
	let count = n
	let arrTemp = []
	let experts = list
	for (let i = 0; i < list.length; i++) {
		index = parseInt(i / count)
		if (arrTemp.length <= index) {
		arrTemp.push([])
		}
		arrTemp[index].push(experts[i])
	}
	return arrTemp
}
// 考试时间校准
function examTime (stime, etime, ntime) {
	var t = (stime + etime) - ntime
	return t
}
// 时间转换
function initMinuter (t) {
	var days = parseInt(t / 60 / 60 / 24, 10) // 计算剩余的天数
	var hours = parseInt(t / 60 / 60 % 24, 10) // 计算剩余的小时
	var minutes = parseInt(t / 60 % 60, 10) // 计算剩余的分钟
	var seconds = parseInt(t % 60, 10) // 计算剩余的秒数
	var timer = ''
	if (days > 0) {
		timer += days + '天'
	}
	if (hours > 0) {
		timer += hours + '小时'
	}
	if (minutes > 0) {
		timer += minutes + '分钟'
	}
	if (seconds > 0) {
		timer += seconds + '秒'
	}
	return timer
  }
// 处理时间格式
function dataFormat (value, fmt) {
  let getDate = new Date(value)
  let o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    'S': getDate.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
// 时间统一函数
function getTimeText (argument) {
  var timeS = argument
  var todayT = ''
  var yestodayT = ''
  var timeCha = getTimeS(timeS)
  timeS = timeS.slice(-8)
  todayT = new Date().getHours() * 60 * 60 * 1000 + new Date().getMinutes() * 60 * 1000 + new Date().getSeconds() * 1000
  yestodayT = todayT + 24 * 60 * 60 * 1000
  if (timeCha > yestodayT) {
	var n = argument.replace(/-/g, '/').replace(/[年月]/g, '/').replace(/[日]/, '')
    return dataFormat(n, 'MM月dd日')
  }
  if (timeCha > todayT && timeCha < yestodayT) {
    return '昨天'
    // return timeS.slice(0, 2) > 12 ? '昨天 下午' + (timeS.slice(0, 2) == 12 ? 12 : timeS.slice(0, 2) - 12) + timeS.slice(2, 5) : '昨天 上午' + timeS.slice(0, 5)
  }
  if (timeCha < todayT) {
    return '今天'
    // return timeS.slice(0, 2) >= 12 ? '下午' + (timeS.slice(0, 2) == 12 ? 12 : timeS.slice(0, 2) - 12) + timeS.slice(2, 5) : '上午' + timeS.slice(0, 5)
  }
}
// 时间戳获取
function getTimeS (argument) {
    var timeS = argument
	timeS = timeS.replace(/-/g, '/').replace(/[年月]/g, '/').replace(/[日]/, '')
    return new Date().getTime() - new Date(timeS).getTime() - 1000 // 有一秒的误差
}
// 手机软键盘收起
function blurIn (_this) {
	window.scrollTo(0, Math.max(_this.scrollHeight - 1, 0))
}
// 检查账户手机验证状态
function ckMobile (callabck) {
	user.ckMobile().then((res) => {
		callabck && callabck(res)
	})
}
// 获取用户信息
function getUserInfo (callabck) {
	user.getUserInfo().then((res) => {
		storage.setStorage('user', res)
		callabck && callabck(res)
	})
}
// 通过pid获取专栏购买地址
function getPackageInfo (pid, callback) {
	api.packageInfo(pid).then((res) => {
		callback && callback(res)
	})
}
// 返回顶部
function goTop () {
	// $('body,html').animate({ scrollTop: 0 }, 500)
	$('.w-scroll').animate({ scrollTop: 0 }, 500)
}
// 设置title，解决微信改不了title的bug
function setTitle (title) {
	document.title = title
	let userAgent = window.navigator.userAgent.toLowerCase()
	let isiOS = userAgent.indexOf('applewebkit') >= 0
	let isWechat = userAgent.indexOf('micromessenger') >= 0
	if (isiOS && isWechat) {
		let iframe = document.createElement('iframe')
		iframe.src = GRoot + 'favicon.ico'
		iframe.style.display = 'none'
		document.body.appendChild(iframe)
		iframe.onload = function () {
			setTimeout(function () {
			iframe.remove()
			}, 0)
		}
	}
}
// 全局判断是否IOS方法
function isIOS () {
	const u = navigator.userAgent
	return u.indexOf('iPhone') > -1 || u.indexOf('Mac OS') > -1
}
// 判断手机端还是PC
function isMobile () {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js